import type { MemoEntry } from "@/lib/types";

export type EntryDisplayKind = "retired" | "open" | "done" | "note";

/**
 * How a memo entry should render (and its carry-forward meaning). Mirrors the
 * backend carry buckets: retired entries drop, tasks show open/done, everything
 * else is a plain note that carries until retired.
 */
export function entryDisplayKind(
  e: Pick<MemoEntry, "retired" | "assignee_user_id" | "task_done">,
): EntryDisplayKind {
  if (e.retired) return "retired";
  if (e.assignee_user_id && e.task_done) return "done";
  if (e.assignee_user_id) return "open";
  return "note";
}
